import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import { PillarActionItem } from '../PillarActionItem';

export const PillarActionItemList = ({
  pillarResource,
  collection: actionItemsCollection,
  onClickActionItem,
  prePlan,
}) => {
  return (
    <FDStack direction={'column'} spacing={2}>
      {actionItemsCollection.resources().list().map((resource) => {
        return (<PillarActionItem
          pillarResource={pillarResource}
          resource={resource}
          key={resource.id()}
          onClick={onClickActionItem}
          prePlan={prePlan}
        />);
      })}
    </FDStack>
  );
};

PillarActionItemList.defaultProps = {
};

PillarActionItemList.propTypes = {
  pillarResource: PropTypes.object.isRequired,
  onClickActionItem: PropTypes.func.isRequired,
  collection: PropTypes.object.isRequired,
  prePlan: PropTypes.bool.isRequired,
};
